<template>
  <v-container
    fluid
    class="fill-height"
  >
    <v-row
      justify="center"
      align="center"
      class="ma-0"
    >
      <marker-view-card
        v-if="isViewMode"
        :mode.sync="mode"
      >
      </marker-view-card>
      <marker-edit-card
        v-else
        :mode.sync="mode"
      >
      </marker-edit-card>
    </v-row>
  </v-container>
</template>

<script>
  import {FEATURE_CARD_STATE} from "../../../../helpers/geometries/constants"
  import {isEqual} from "lodash/lang"
  import MarkerViewCard from "./MarkerViewCard"
  import MarkerEditCard from "./MarkerEditCard"
  import {ProcessingGeometry} from "../../../../helpers/geometries/models"

  const _MarkerMap = Symbol.for("_MarkerMap")
  const _MarkerLayer = Symbol.for("_MarkerLayer")
  const _MarkerFeature = Symbol.for("_MarkerFeature")

  export default {
    name: "MarkerCardWrapper",
    components: {MarkerEditCard, MarkerViewCard},
    props: {
      feature: {
        type: ProcessingGeometry,
        required: true,
      },
      map: {
        type: Object,
        required: true,
      },
      layer: {
        type: window.L.Marker,
        required: true
      }
    },
    data: () => ({
      mode: FEATURE_CARD_STATE.VIEW,
    }),
    provide() {
      return {
        [_MarkerFeature]: () => this.feature,
        [_MarkerLayer]: () => this.layer,
        [_MarkerMap]: () => this.map
      }
    },
    computed: {
      isViewMode() {
        return isEqual(this.mode, FEATURE_CARD_STATE.VIEW)
      },
    },
  }
</script>

<style scoped>

</style>
